import { Component, Input } from '@angular/core';
import { AccountingItem } from '../../accounting.models';

export interface CosmolexAccountingItem extends AccountingItem {
	hst: boolean;
}

@Component({
	selector: 'app-cosmolex-accounting-items-table',
	templateUrl: './cosmolex-accounting-items-table.component.html',
	styleUrls: ['./cosmolex-accounting-items-table.component.scss'],
	standalone: false,
})
export class CosmolexAccountingItemsTableComponent {
	public displayedColumns: string[] = ['title', 'amount'];

	public items: CosmolexAccountingItem[] = [];

	@Input('items') set _items(items: CosmolexAccountingItem[]) {
		this.items = items;
		this.total = items.reduce((acc, item) => acc + item.amount, 0);
	}

	@Input() title = '';

	@Input() hst: number = null;
	@Input() hstTotal: number = null;

	public total = 0;
}
